import React from 'react'
import CardEdit from '../../components/allCards/CardEdit'
import SidebarNew from '../../components/sidebar/SidebarNew'
import { Layout } from 'antd';
const { Content } = Layout;

function EditCardPage() {
    return (

        <div className="flex flex-col">
            <div className="flex flex-col">

                <div className="flex ">
                    <div className=" h-full   z-10 overflow-y-auto ">
                        <SidebarNew />
                    </div>
                    <div className="lg:flex-1  overflow-auto scrollbar-hide h-screen  w-full md:z-10   p-4 lg:p-10 md:p-10">
                        <CardEdit edit={'edit'} />
                    </div>
                </div>
            </div>
        </div>

    )
}

export default EditCardPage